import script from "./GestaoProcessosMunicipioAbasView_67.vue?vue&type=script&setup=true&lang=js"
export * from "./GestaoProcessosMunicipioAbasView_67.vue?vue&type=script&setup=true&lang=js"

import "./GestaoProcessosMunicipioAbasView_67.vue?vue&type=style&index=0&id=6d9349ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9349ec"]])

export default __exports__